module.exports = __webpack_public_path__ + "img/logo_2027.0bd82492.png";